import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TypeProject, TypeProjectForm } from '../models';

@Injectable()
export class TypeProjectService {

    typeProjectsUrl = environment.dns + 'api/type/projects/';

    constructor(private http: HttpClient) { }

    getList(): Observable<TypeProject[]> {
        return this.http.get<TypeProject[]>(this.typeProjectsUrl + 'list');
    }

    getOne(id: number): Observable<TypeProject> {
        return this.http.get<TypeProject>(this.typeProjectsUrl + id);
    }

    add(typeProjectForm: TypeProjectForm): Observable<TypeProject> {
        return this.http.post<TypeProject>(this.typeProjectsUrl, typeProjectForm);
    }

    update(typeProjectForm: TypeProjectForm): Observable<TypeProject> {
        return this.http.put<TypeProject>(this.typeProjectsUrl, typeProjectForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.typeProjectsUrl + id);
    }
}